import marked, { MarkedOptions } from 'marked';

function markdown(src: string, options?: MarkedOptions, newTab = false) {
  const renderer = new marked.Renderer();
  renderer.link = function (href: string, title: string, text: string) {
    // eslint-disable-next-line prefer-rest-params
    const link = marked.Renderer.prototype.link.apply(this, [
      href,
      title,
      text,
    ]);
    if (newTab) {
      return link.replace(
        '<a',
        "<a class='text-pos-hyperlink' target='_blank'",
      );
    }
    return link.replace('<a', "<a class='text-pos-hyperlink' target='_self'");
  };

  marked.setOptions({
    renderer,
  });

  return marked(src, options);
}

export default markdown;
